<template>
    <div>

    </div>
</template>

<script>
export default {
    name: "SupplierStat"
}
</script>

<style scoped>

</style>